/**
 * Encodes S3 URIs to ensure special characters (spaces, parentheses, etc.) are properly URL-encoded.
 * Uses decode-then-encode pattern to be idempotent (safe to call multiple times).
 *
 * @param uri - The URI string to sanitize (may or may not be already encoded)
 * @returns Properly URL-encoded URI string, or the original value if parsing fails
 */
export function sanitizeUri(uri: string): string {
  // Return as-is for falsy values (null, undefined, empty string)
  if (!uri) return uri

  try {
    const url = new URL(uri)

    // Decode first (handles already-encoded), then re-encode each path segment
    const pathSegments = url.pathname.split('/')
    const encodedSegments = pathSegments.map((segment) => encodeURIComponent(decodeURIComponent(segment)))
    url.pathname = encodedSegments.join('/')

    return url.toString()
  } catch {
    // If URL parsing fails, return as-is
    return uri
  }
}
